/* Idee regalo — logica della pagina (sections/tc-gift.liquid).
   Stessa logica della vecchia pagina incollata nel corpo Shopify:
   - 9 "collezioni" (8 collezioni Shopify/tipo prodotto + Gift Card) con titoli e descrizioni IT/EN
   - copertina = prima foto della collezione; al clic si apre l'elenco prodotti (15 per pagina)
   - la Gift Card porta direttamente alla scheda prodotto
   Dati e testi copiati dall'originale senza modifiche. */
(function () {
  "use strict";

  var root = document.querySelector("[data-tc-gift]");
  if (!root) return;

  var isEn = root.dataset.lang === "en";
  if (isEn) document.title = "Gift Ideas";

  var views = root.querySelectorAll(".tc-gift__view");
  var viewsContainer = document.getElementById("tc-gift-views");
  var listContainer = document.getElementById("categories-list");
  var productsGrid = document.getElementById("products-grid");
  var collectionTitleEl = document.getElementById("collection-title");
  var collectionDescEl = document.getElementById("collection-desc");
  var paginationContainer = document.getElementById("pagination-container");

  function tcNav(targetViewId) {
    views.forEach(function (v) { v.classList.remove("is-active"); });
    document.getElementById(targetViewId).classList.add("is-active");

    // Scrolla su quando si cambia vista
    var headerOffset = 100;
    var elementPosition = viewsContainer.getBoundingClientRect().top;
    window.scrollTo({ top: elementPosition + window.pageYOffset - headerOffset, behavior: "smooth" });
  }

  document.getElementById("tc-gift-back").addEventListener("click", function () { tcNav("view-categories"); });

  /* Le foto dei prodotti arrivano dal CDN Shopify a dimensione piena: chiediamo la larghezza che serve */
  function sized(url, width) {
    if (!url || typeof url !== "string") return url || "";
    if (url.indexOf("cdn.shopify.com") === -1 && url.indexOf("/cdn/shop/") === -1) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  const fallbackImages = {
      'kokedama': 'https://cdn.shopify.com/s/files/1/0857/9268/6416/files/IMG_3858.png?v=1782398221',
      'mystery-box': 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?auto=format&fit=crop&w=600&q=80',
      'tillandsia': 'https://cdn.shopify.com/s/files/1/0857/9268/6416/files/WhatsApp_Image_2026-06-26_at_11.59.45.jpg?v=1782469257',
      'succuset': 'https://cdn.shopify.com/s/files/1/0857/9268/6416/files/ChatGPT_Image_25_giu_2026_17_06_13.png?v=1782400047',
      'plant-plushies': 'https://images.unsplash.com/photo-1515041219749-89347f83291a?auto=format&fit=crop&w=600&q=80',
      'minigarden': 'https://images.unsplash.com/photo-1509423350716-97f9360b4e09?auto=format&fit=crop&w=600&q=80',
      'accessori': 'https://images.unsplash.com/photo-1584589167171-541ce45f1eea?auto=format&fit=crop&w=600&q=80',
      'kit-completi': 'https://images.unsplash.com/photo-1604762524889-3e2fcc145683?auto=format&fit=crop&w=600&q=80',
  };

  const collections = [
      { handle: 'kokedama', title: isEn ? 'Kokedama' : 'Kokedama', description: isEn ? "The art of cultivating beauty without a pot.<br>Discover Japanese elegance with our new Kokedama collection, spheres of live natural moss that encapsulate the essence of nature.<br>Every Kokedama is a living work of art, perfect for bringing a unique and refined touch of green to any environment.<br>Kokedamas are easy to care for and perfect to display on shelves, or to hang.<br>Let yourself be conquered by the magic of natural simplicity." : "L'arte di coltivare la bellezza senza vaso.<br>Scopri l’eleganza giapponese con la nostra nuova collezione di Kokedama, sfere di muschio naturale vivo che racchiudono l’essenza della natura.<br>Ogni Kokedama è un'opera d'arte viva, perfetta per portare un tocco di verde unico e raffinato in qualsiasi ambiente.<br>I Kokedama sono facili da curare e perfetti da esporre su mensole, o da sospendere.<br>Lasciati conquistare dalla magia della semplicità naturale." },
      { handle: 'mystery-box', title: isEn ? 'Mystery Boxes' : 'Mystery Boxes', description: isEn ? "Mystery boxes contain surprise plants:<br>Perfect for you, if you love the element of surprise.<br>Perfect to gift, to surprise those you love.<br>Are you curious? Choose your favorite!" : "Le mystery box contengono piante a sopresa:<br>Perfette per te, se ami l'effetto sorpresa.<br>Perfette da regalare, per sorprendere chi ami.<br>Sei curioso? Scegli la tua preferita!" },
      { handle: 'tillandsia', title: isEn ? 'Tillandsias' : 'Tillandsie', isProductType: true, productType: 'Tillandsia', description: isEn ? 'Discover our beautiful air plants. Tillandsias do not need soil to grow and bring a touch of green to any space.' : 'Scopri le nostre meravigliose piante aeree. Le Tillandsie non hanno bisogno di terra per vivere e donano un tocco di verde a qualsiasi ambiente.' },
      { handle: 'succuset', title: isEn ? 'SuccuSet' : 'SuccuSet', description: isEn ? "Looking for a gift idea or an arrangement<br>to enrich your green spaces effortlessly?<br>Discover our SuccuSet selection:<br>cute decorative pots, accompanied by colorful and lovely succulent plants!<br>SuccuSets might require a different processing time than usual." : "Sei alla ricerca di un'idea regalo o di una composizione<br>per arricchire i tuoi spazi green senza sforzi?<br>Scopri la nostra selezione di SuccuSet:<br>simpatici vasi decorativi, accompagnati da colorate e graziose piante succulente!<br>I SuccuSet potrebbero richiedere un tempo di elaborazione dell'ordine diverso da quello abituale." },
      { handle: 'plant-plushies', title: isEn ? 'Plant Plushies' : 'Plant Plushies', description: isEn ? "Would you like to hug a cactus? Now you can.<br>A corner where plants become soft:<br>plushies inspired by the plant world, created to bring a smile, a bit of green, and lots of softness to your home.<br>Plant-Plushies are perfect to decorate your Tropical corner with great personality, or as a gift idea for those you love.<br>Cuddle them, collect them or gift them: choose your favorites and dive into softness!" : "Vorresti abbracciare un cactus? Adesso puoi.<br>Un angolo dove le piante diventano soffici:<br>peluche ispirati al mondo delle piante, che nascono per portare un sorriso, un po' di verde e tanta morbidezza a casa tua.<br>Plant-Plushies perfetti per decorare il tuo Tropical corner con grande personalità, o come idea regalo per chi ami.<br>Coccolali, collezionali o regalali: scegli i tuoi preferiti e tuffati nella morbidezza!" },
      { handle: 'minigarden', title: isEn ? 'Minigarden' : 'Minigarden', description: isEn ? "Choose your favorite MiniGarden and discover the 2 in 1!<br>Little natural wonders enclosed in a glass bottle.<br>Every MiniGarden is an autonomous ecosystem, designed to bring a touch of green to any environment, even in small spaces." : "Scegli il tuo MiniGarden preferito e scopri il 2 in 1!<br>Piccole meraviglie naturali racchiuse in glass bottle.<br>Ogni MiniGarden è un ecosistema autonomo, ideato per portare un tocco di verde in qualsiasi ambiente, anche in spazi ridotti." },
      { handle: 'accessori', title: isEn ? 'Accessories' : 'Accessori', description: isEn ? "Here you can find useful accessories for plant care:<br>practical solutions to grow them with ease." : "Qui puoi trovare accessori utili per la cura delle tue piante:<br>soluzioni pratiche per coltivarle con facilità." },
      { handle: 'kit-completi', title: isEn ? 'Complete Kits' : 'Kit Completi', description: isEn ? "Our complete kits designed for all needs, ready to use!" : "I nostri kit completi pensati per tutte le esigenze, pronti all'uso!" },
      {
          handle: 'gift-card',
          title: 'Gift Card',
          isStatic: true,
          url: isEn ? 'https://tropical-corner.com/en/products/tropical-gift-card' : 'https://tropical-corner.com/products/tropical-gift-card',
          image: 'https://tropical-corner.com/cdn/shop/files/ChatGPT_Image_19_ago_2025_20_09_02.png?v=1755626963&width=713',
          description: isEn ? 'The perfect gift' : 'Il regalo perfetto',
          price: isEn ? 'From €25.00' : 'Da €25,00'
      }
  ];

  // Caching dei prodotti per evitare fetch doppi
  var collectionCache = {};

  // Stato Paginazione
  var currentProducts = [];
  var currentPage = 1;
  var itemsPerPage = 15;

  function formatPrice(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return "";
    if (isEn) return "€" + num.toFixed(2);
    return "€" + num.toFixed(2).replace(".", ",");
  }

  async function fetchCollectionProducts(handle, limit = 250) {
      try {
          const res = await fetch(`/collections/${handle}/products.json?limit=${limit}`);
          if (!res.ok) return [];
          const data = await res.json();
          return data.products || [];
      } catch (err) {
          console.error('Error fetching products for', handle, err);
          return [];
      }
  }

  async function fetchProductsByProductType(productType, limit = 250) {
      try {
          let allProducts = [];
          let page = 1;
          let hasMore = true;
          while (hasMore && page <= 4) {
              const res = await fetch(`/products.json?limit=${limit}&page=${page}`);
              if (!res.ok) break;
              const data = await res.json();
              const products = data.products || [];
              if (products.length === 0) {
                  hasMore = false;
              } else {
                  const filtered = products.filter(p => {
                      const type = p.product_type ? p.product_type.toLowerCase() : '';
                      return type === 'tillandsia' || type === 'tillandsie';
                  });
                  allProducts = allProducts.concat(filtered);
                  if (products.length < limit) {
                      hasMore = false;
                  } else {
                      page++;
                  }
              }
          }
          return allProducts;
      } catch (err) {
          console.error('Error fetching products by type', productType, err);
          return [];
      }
  }

  var ARROW =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  // 1. CARICAMENTO COLLEZIONI (vista principale)

  function buildTile(col, coverImage, count, idx) {
    var tile = document.createElement(col.isStatic ? "a" : "button");
    tile.className = "tc-gift__tile";
    if (col.isStatic) tile.href = col.url;
    else tile.type = "button";

    var media = '<span class="tc-gift__tile-media"><img src="' + esc(sized(coverImage, col.isStatic ? 1000 : 700)) + '" alt="" width="700" height="784"' +
      (idx < 4 ? ' fetchpriority="high"' : ' loading="lazy"') + ' decoding="async"></span>';
    if (col.isStatic) {
      /* Gift Card: banner a tutta larghezza */
      tile.className += " tc-gift__tile--feature";
      tile.innerHTML = media +
        '<span class="tc-gift__tile-body"><span class="tc-gift__tile-kicker">' + esc(col.description) + '</span>' +
        '<span class="tc-gift__tile-title">' + esc(col.title) + '</span>' +
        (col.price ? '<span class="tc-gift__tile-meta">' + esc(col.price) + "</span>" : "") +
        '<span class="tc-gift__tile-cta">' + (isEn ? "Discover" : "Scopri") + ARROW + "</span></span>";
    } else {
      var meta = count > 0 ? (count + " " + (isEn ? (count === 1 ? "product" : "products") : (count === 1 ? "prodotto" : "prodotti"))) : "";
      tile.innerHTML = media +
        '<span class="tc-gift__tile-body"><span class="tc-gift__tile-text"><span class="tc-gift__tile-title">' + esc(col.title) + "</span>" +
        (meta ? '<span class="tc-gift__tile-meta">' + meta + "</span>" : "") +
        '</span><span class="tc-gift__tile-arrow">' + ARROW + "</span></span>";
      tile.addEventListener("click", function () { openCollection(col); });
    }
    return tile;
  }

  async function loadCategories() {
    // gli scheletri sono già nell'HTML (tc-gift.liquid): restano finché è pronto tutto, poi le tile compaiono insieme
    var loaded = await Promise.all(collections.map(async function (col) {
      var coverImage = fallbackImages[col.handle] || "https://images.unsplash.com/photo-1459156212016-c812468e2115?auto=format&fit=crop&w=600&q=80";
      var count = 0;
      if (col.isStatic) {
        coverImage = col.image;
      } else {
        var products = col.isProductType ? await fetchProductsByProductType(col.productType) : await fetchCollectionProducts(col.handle);
        collectionCache[col.handle] = products;
        count = products.length;
        if (products.length > 0) {
          var p = products[0];
          coverImage = p.featured_image || (p.image && p.image.src) || (p.images && p.images[0] && p.images[0].src) || (p.images && p.images[0]) || coverImage;
        }
      }
      return { col: col, coverImage: coverImage, count: count };
    }));

    listContainer.innerHTML = "";
    loaded.forEach(function (d, idx) {
      listContainer.appendChild(buildTile(d.col, d.coverImage, d.count, idx));
    });
  }

  // 2. APERTURA VISTA PRODOTTI
  function openCollection(col) {
    collectionTitleEl.innerText = col.title;
    if (col.description) {
      collectionDescEl.innerHTML = col.description;
    } else {
      collectionDescEl.innerHTML = "";
    }
    productsGrid.innerHTML = "";

    tcNav("view-products");

    var products = collectionCache[col.handle] || [];
    if (products.length > 0) {
      currentProducts = products;
      currentPage = 1;
      renderProductsPage(true);
    } else {
      productsGrid.innerHTML = '<div class="tc-gift__empty">' + (isEn ? "No products found." : "Nessun prodotto trovato.") + "</div>";
      paginationContainer.innerHTML = "";
    }
  }

  function renderProductsPage(skipScroll) {
    var totalPages = Math.ceil(currentProducts.length / itemsPerPage);
    var startIndex = (currentPage - 1) * itemsPerPage;
    var productsToShow = currentProducts.slice(startIndex, startIndex + itemsPerPage);

    productsGrid.innerHTML = "";
    renderProducts(productsToShow);
    renderPagination(totalPages);

    // Scroll in cima alla vista (già fatto da tcNav alla prima apertura)
    if (!skipScroll) {
      var viewEl = document.getElementById("view-products");
      var topPos = viewEl.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: topPos, behavior: "smooth" });
    }
  }

  function pageButton(label, onClick, opts) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "tc-gift__page-btn" + (opts && opts.active ? " is-active" : "");
    b.innerHTML = label;
    if (opts && opts.disabled) b.disabled = true;
    if (opts && opts.active) b.setAttribute("aria-current", "page");
    b.addEventListener("click", onClick);
    return b;
  }

  function renderPagination(totalPages) {
    paginationContainer.innerHTML = "";
    if (totalPages <= 1) return;

    paginationContainer.appendChild(pageButton("&lt;", function () {
      if (currentPage > 1) { currentPage--; renderProductsPage(); }
    }, { disabled: currentPage === 1 }));

    for (var i = 1; i <= totalPages; i++) {
      (function (n) {
        paginationContainer.appendChild(pageButton(String(n), function () { currentPage = n; renderProductsPage(); }, { active: n === currentPage }));
      })(i);
    }

    paginationContainer.appendChild(pageButton("&gt;", function () {
      if (currentPage < totalPages) { currentPage++; renderProductsPage(); }
    }, { disabled: currentPage === totalPages }));
  }

  // 3. RENDER PRODOTTI NELLA GRIGLIA
  function renderProducts(products) {
    products.forEach(function (product, idx) {
      var card = document.createElement("a");
      card.className = "tc-gift__card";

      var productUrl = product.url || "/products/" + product.handle;
      if (isEn && productUrl.indexOf("/en/") !== 0) {
        productUrl = "/en" + productUrl;
      }
      card.href = productUrl;

      var image = product.featured_image || (product.image && product.image.src) || (product.images && product.images[0] && product.images[0].src) || (product.images && product.images[0]) || "";
      var variant = product.variants && product.variants[0];
      var priceNowHtml = "";
      var compareHtml = "";

      if (variant) {
        var priceVal = parseFloat(variant.price);
        var compareVal = parseFloat(variant.compare_at_price);

        if (!isNaN(priceVal)) {
          priceNowHtml = '<span class="price-now">' + formatPrice(priceVal) + "</span>";
        }
        if (!isNaN(compareVal) && compareVal > priceVal) {
          compareHtml = '<span class="price-compare">' + formatPrice(compareVal) + "</span>";
        }
      } else if (product.price) {
        priceNowHtml = '<span class="price-now">' + formatPrice(product.price) + "</span>";
      }

      var title = product.title || product.name || (isEn ? "Product" : "Prodotto");
      var soldOut = !!(product.variants && product.variants.length && product.variants.every(function (v) { return v.available === false; }));
      var badge = "";
      if (soldOut) badge = '<span class="tc-gift__badge">' + (isEn ? "Sold out" : "Esaurito") + "</span>";
      else if (compareHtml && variant) badge = '<span class="tc-gift__badge tc-gift__badge--sale">-' + Math.round((1 - parseFloat(variant.price) / parseFloat(variant.compare_at_price)) * 100) + "%</span>";
      var alt = product.images && product.images[1] && (product.images[1].src || product.images[1]);
      if (soldOut) card.className += " is-soldout";

      card.innerHTML =
        '<span class="tc-gift__card-media"><img src="' + esc(sized(image, 600)) + '" alt="' + esc(title) + '" width="600" height="750"' +
        (idx < 4 ? "" : ' loading="lazy"') + ' decoding="async">' +
        (alt ? '<img class="tc-gift__alt" src="' + esc(sized(alt, 600)) + '" alt="" width="600" height="750" loading="lazy" decoding="async">' : "") + badge + '</span>' +
        '<span class="tc-gift__card-body"><h3 class="tc-gift__card-title">' + esc(title) + '</h3>' +
        '<span class="tc-gift__price">' + priceNowHtml + compareHtml + "</span></span>";

      productsGrid.appendChild(card);
    });
  }

  // Inizializza
  loadCategories();
})();
